import React from "react";
import Live from "./Live";
import Roll from "./Roll";

const kvPng = "./assets/kv.png";
const kvPng2x = "./assets/kv@2x.png 2x";

function Kv() {
    return (
        <div className="kv">
            <Live />
            <Roll />
            <img
                width="430px"
                height="670px"
                src={kvPng}
                srcSet={kvPng2x}
                className="kv-image"
            />
        </div>
    );
}

export default Kv;
